<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Arqueo</h3>
            </div>
            <div class="col-6 text-right">

            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <span class="col-3">Momento inicio:</span>
            <date-picker
              class="col-3"
              v-model="arqueo.fecha_inicio"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
            <span class="col-2">Momento fin:</span>
            <date-picker
              class="col-3"
              v-model="arqueo.fecha_fin"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>

            <span class="col-2 mt-3">Agencia:</span>
            <multiselect class="col-3 mt-3" :disabled="isDisabledAgencia" v-model="arqueo.agencia_seleccionada" :options="agencias" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione agencia" track-by="id" label="nombre" :showLabels="false"></multiselect>
            <span class="mt-3">Usuario de agencia:</span>
            <multiselect class="col-3 mt-3" :disabled="isDisabledUsuarioAgencia" v-model="arqueo.usuario" :options="usuarios" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione usuario" track-by="id" label="name" :showLabels="false"></multiselect>
          </div>
          <div class="col-12 mt-3 mb-3">
            <button type="button" class="btn btn-default ml-auto hover-apolo" @click="consultar()">Consultar</button>
            <button type="button" class="btn btn-default ml-auto hover-apolo" :disabled="isDisabledImprimir" @click="imprimir('Arqueo')">Imprimir</button>
          </div>
          <br>
          <div class="row">
            <div class="col-6">
              <span v-if="consulta != null" class="col-2">Ingresos Totales:</span>
              <el-table v-if="consulta != null"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="ingresos"
                @sort-change="sortChange"
              >
                <div slot="empty" v-if="loading">
                  <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>
                <div slot="empty" v-if="agencias">
                  Sin datos disponibles
                </div>
                <el-table-column label="Método">
                  <div slot-scope="{ row }" class="table-actions">
                    <span style="cursor: pointer !important; color: #0068a0 !important;" v-if="row.nombre === 'Efectivo'" @click="showTableMetodoEfectivo()">{{row.nombre}}</span>
                    <span style="cursor: pointer !important; color: #0068a0 !important;"  v-else @click="showTableMetodos(row.nombre)">{{row.nombre}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="# Movimientos" prop="movimiento" />
                <el-table-column label="Monto" prop="monto" />
              </el-table>
            </div>
            <div class="col-6">
              <span v-if="consulta != null" class="col-2">Egresos Totales:</span>
              <el-table v-if="consulta != null"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="egresos"
                @sort-change="sortChange"
              >
                <div slot="empty" v-if="loading">
                  <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>
                <div slot="empty" v-if="agencias">
                  Sin datos disponibles
                </div>
                <el-table-column label="">
                  <div slot-scope="{ row }" class="table-actions">
                    <span style="cursor: pointer !important; color: #0068a0 !important;" @click="showTableEgresos()">{{row.nombre}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="# Movimientos" prop="movimiento" />
                <el-table-column label="Monto" prop="monto" />
              </el-table>
            </div>
            <div class="col-12 text-center">
              <span v-if="consulta != null">Total Efectivo MXN en Caja: <strong>${{(Number(consulta.ingresos_efectivo_mxn[0].monto) - Number(consulta.egresos[0].monto)).toFixed(2)}}</strong></span>
            </div>
            <div class="col-12 my-4 text-center">
              <span v-if="consulta != null" class="col-12 mx-4">Movimientos de caja</span>
            </div>

            <div class="col-6">
              <span v-if="consulta != null" class="col-2">Ingresos	Detalles:</span>
              <el-table v-if="consulta != null"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="consulta.impresion_ingresos_efectivo_mxn"
                @sort-change="sortChange"
              >
                <div slot="empty" v-if="consulta.impresion_ingresos_efectivo_mxn">
                  Sin datos disponibles
                </div>
                <el-table-column label="ID" prop="id" />
                <el-table-column label="Fecha">
                  <div slot-scope="{ row }" class="table-actions">
                    <span>{{row.created_at | moment('DD-MM-YYYY HH:mm:ss')}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="Usuario" prop="created_by" />
                <el-table-column label="Motivo" prop="motivo" />
                <el-table-column label="Detalles" prop="detalles" />
                <el-table-column label="Monto">
                  <div slot-scope="{ row }" class="table-actions">
                    <span>${{row.monto}}</span>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div class="col-6">
              <span v-if="consulta != null" class="col-2">Egresos	Detalles:</span>
              <el-table v-if="consulta != null"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="consulta.detalle_egresos"
                @sort-change="sortChange"
              >
                <div slot="empty" v-if="consulta.detalle_egresos">
                  Sin datos disponibles
                </div>
                <el-table-column label="ID" prop="id" />
                <el-table-column label="Fecha">
                  <div slot-scope="{ row }" class="table-actions">
                    <span>{{row.created_at | moment('DD-MM-YYYY HH:mm:ss')}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="Usuario" prop="created_by" />
                <el-table-column label="Motivo" prop="motivo" />
                <el-table-column label="Detalles" prop="detalles" />
                <el-table-column label="Monto">
                  <div slot-scope="{ row }" class="table-actions">
                    <span>${{row.monto}}</span>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center flex-wrap"
        >
        </div>
      </card>
    </div>
    <modal :show.sync="showTableMetodoEfectivoModal" size="lg" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Movimientos de Ingresos Efectivo</h6>        
      <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="imprimir('Efectivo')">Imprimir</button>
      <form class="new-event--form">
        <el-table v-if="consulta != null"
          class="table-responsive align-items-center table-flush"
          header-row-class-name="thead-light"
          :data="consulta.detalle_ingresos_efectivo_mxn"
          @sort-change="sortChange"
        >
          <div slot="empty" v-if="consulta.detalle_ingresos_efectivo_mxn">
            Sin datos disponibles
          </div>
          <el-table-column label="# Boleto">
            <div slot-scope="{ row }" class="table-actions">
              <span v-if="row.tipo_entidad == 'Boleto'">{{row.entidad_id}}</span>
              <span v-else>-</span>
            </div>
          </el-table-column>
          <el-table-column label="Fecha">
            <div slot-scope="{ row }" class="table-actions">
              <span>{{row.created_at | moment('DD-MM-YYYY HH:mm:ss')}}</span>
            </div>
          </el-table-column>
          <el-table-column label="Usuario" prop="created_by" />
          <el-table-column label="Motivo" prop="motivo" />
          <el-table-column label="Detalles" prop="detalles" />
          <el-table-column label="Recibido">
            <div slot-scope="{ row }" class="table-actions">
              <span>${{row.efectivo_mxn}}</span>
            </div>
          </el-table-column>
          <el-table-column label="Cambio">
            <div slot-scope="{ row }" class="table-actions">
              <span>${{row.cambio}}</span>
            </div>
          </el-table-column>
        </el-table>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </form>

      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showTableMetodoEfectivoModal = false">Cerrar</button>
      </template>
    </modal>
    <modal :show.sync="showTableMetodosModal" size="lg" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Movimientos de Ingresos {{ tabla_titulo }}</h6>        
      <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="imprimir(tabla_titulo)">Imprimir</button>
      <form class="new-event--form">
        <el-table v-if="consulta != null"
          class="table-responsive align-items-center table-flush"
          header-row-class-name="thead-light"
          :data="tabla_detalles"
          @sort-change="sortChange"
        >
          <div slot="empty" v-if="tabla_detalles">
            Sin datos disponibles
          </div>
          <el-table-column label="ID" prop="id" />
          <el-table-column label="Fecha">
            <div slot-scope="{ row }" class="table-actions">
              <span>{{row.created_at | moment('DD-MM-YYYY HH:mm:ss')}}</span>
            </div>
          </el-table-column>
          <el-table-column label="Usuario" prop="created_by" />
          <el-table-column label="Motivo" prop="motivo" />
          <el-table-column label="Detalles" prop="detalles" />
          <el-table-column label="Recibido">
            <div slot-scope="{ row }" class="table-actions">
              <span v-if="row.metodo === 'Efectivo'">${{row.efectivo_mxn}}</span>
              <span v-if="row.metodo === 'Tarjeta'">${{row.tarjeta}}</span>
              <!--
              <span v-if="row.metodo === 'Efectivo USD'">${{row.efectivo_usd}}</span>
              
              
              <span v-if="row.metodo === 'Depósito'">${{row.deposito}}</span>
              
              <span v-if="row.metodo === 'Mixto' && tabla_titulo === 'Efectivo USD'">${{row.efectivo_usd}}</span>
              <span v-if="row.metodo === 'Mixto' && tabla_titulo === 'Efectivo'">${{row.efectivo_mxn}}</span>
              <span v-if="row.metodo === 'Mixto' && tabla_titulo === 'Tarjeta'">${{row.tarjeta}}</span>
              <span v-if="row.metodo === 'Mixto' && tabla_titulo === 'Depósito a Cuenta'">${{row.deposito}}</span>
              -->
            </div>
          </el-table-column>
        </el-table>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </form>

      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showTableMetodosModal = false">Cerrar</button>
      </template>
    </modal>
    <modal :show.sync="showTableEgresosModal" size="lg" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Movimientos de Egresos</h6>        
      <form class="new-event--form">
        <el-table v-if="consulta != null"
          class="table-responsive align-items-center table-flush"
          header-row-class-name="thead-light"
          :data="consulta.detalle_egresos"
          @sort-change="sortChange"
        >
          <div slot="empty" v-if="consulta.detalle_egresos">
            Sin datos disponibles
          </div>
          <el-table-column label="ID" prop="id" />
          <el-table-column label="Fecha">
            <div slot-scope="{ row }" class="table-actions">
              <span>{{row.created_at | moment('DD-MM-YYYY HH:mm:ss')}}</span>
            </div>
          </el-table-column>
          <el-table-column label="Usuario" prop="created_by" />
          <el-table-column label="Motivo" prop="motivo" />
          <el-table-column label="Detalles" prop="detalles" />
          <el-table-column label="Monto">
            <div slot-scope="{ row }" class="table-actions">
              <span>${{row.monto}}</span>
            </div>
          </el-table-column>
        </el-table>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </form>

      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showTableEgresosModal = false">Cerrar</button>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from 'vue';
import {Impresora} from "@/printer/Impresora.js";
import ImpresionArqueo from "./ImpresionArqueo.vue";
import ImpresionArqueoNew from "./ImpresionArqueoNew.vue";
import { BasePagination, Modal } from "@/components/";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es/es";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import axios from "axios";
import "sweetalert2/dist/sweetalert2.css";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import Multiselect from "vue-multiselect";

export default {
  layout: "DashboardLayout",

  components: {
    DatePicker,
    Multiselect,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [formMixin],

  data() {
    return {
      agencias: [],
      usuarios: [],
      terminales: [],
      arqueo: {
        fecha_inicio: new Date(new Date().setHours(0,0,0,0)),
        fecha_fin: new Date(),
        agencia_id: 0,
        agencia_seleccionada: null,
        agencia_seleccionada_id: null,
        usuario: null,
        user_id: null
      },
      permiso: {
        permiso: null,
        validacion: null
      },
      ingresos: [
          { id: 1, nombre: 'Efectivo'},
          { id: 3, nombre: 'Tarjeta'}
        ],
      egresos: [
          { id: 1, nombre: 'Egresos Caja'}
        ],
      consulta: null,
      consulta_validacion: false,
      tabla_detalles: null,
      tabla_titulo: null,
      showTableMetodoEfectivoModal: false,
      showTableMetodosModal: false,
      showTableEgresosModal: false,
      sort: "created_at",

      pagination: {
        perPage: 1,
        currentPage: 1,
        perPageOptions: [
          { value: "1", descripcion: "Cualquier Usuario" },
          { value: "2", descripcion: "Usuario 1" },
          { value: "3", descripcion: "Usuario 2" },
          { value: "4", descripcion: "Usuario 3" },
        ],
      },

      total: 0,
      loading: true,
    };
  },

  created() {
    this.getAgencias();
    this.authAgencias();
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    isDisabledAgencia(){
      if(this.permiso.validacion === true){
        return false;
      }else{
        return true;
      }
    },
    isDisabledUsuarioAgencia(){
      if(this.arqueo.agencia_seleccionada != null){
        return false;
      }else{
        return true;
      }
    },
    isDisabledImprimir(){
      if(this.consulta_validacion == true){
        return false;
      }else{
        return true;
      }
    },
  },

  watch: {
    'arqueo.agencia_seleccionada': {
      handler: "getUsuarios",
      immediate: false,
    },

    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    showTableMetodoEfectivo(){
      this.showTableMetodoEfectivoModal = true;
    },

    showTableEgresos(){
      this.showTableEgresosModal = true;
    },

    showTableMetodos(metodo){
      if(metodo === 'Efectivo USD'){
        this.tabla_detalles = this.consulta.detalle_ingresos_efectivo_usd;
      }
      if(metodo === 'Tarjeta'){
        this.tabla_detalles = this.consulta.detalle_ingresos_tarjeta;
      }
      if(metodo === 'Depósito a Cuenta'){
        this.tabla_detalles = this.consulta.detalle_ingresos_deposito;
      }
      this.tabla_titulo = metodo;
      this.showTableMetodosModal = true;
    },
    async addImageToPrint(linea){
      //transforma imagen a base64
      const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob); 
          reader.onloadend = () => {
            const base64data = reader.result;   
            resolve(base64data);
          }
        });
      }
      let imagen;
      //elige imagen a imprimir según linea de ruta
      switch(linea){
        case 1:
          imagen = await getBase64FromUrl('/img/logoPrinter.png');
          return imagen;
        case 2:
          imagen = await getBase64FromUrl('/img/logoPrinter3.png');
          return imagen;
      }
    },
    async imprimir(tipo) {
      //se obtienen datos de usuario autenticado
      let me = await this.$store.getters["profile/me"];
      let linea = 2;
      let imagen = await this.addImageToPrint(linea);
      let printer = new Impresora;
      //console.log(tipo.toString());
      if(tipo.toString() === 'Arqueo'){
        let tablaClass = Vue.extend(ImpresionArqueoNew);
        let tablaInstancia = new tablaClass({
          propsData: { 
            arqueo: this.arqueo,
            consulta: this.consulta,
            user: me.attributes,
            tipo: tipo.toString()
          }
        });
        let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
        let tabla = this.changeSimbol(tabla_html);
        printer.setAlign("center");
        printer.imagen(imagen);
        printer.setAlign("left");
        printer.html(tabla);
        printer.cut();
      }else{
        let tablaClass = Vue.extend(ImpresionArqueo);
        let tablaInstancia = new tablaClass({
          propsData: { 
            arqueo: this.arqueo,
            consulta: this.consulta,
            user: me.attributes,
            tipo: tipo.toString()
          }
        });
        let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
        let tabla = this.changeSimbol(tabla_html);
        printer.setAlign("center");
        printer.imagen(imagen);
        printer.setAlign("left");
        printer.html(tabla);
        printer.cut();
      }
      printer.end().then(respuesta => {
          this.reload();
      });
    },

    reload(){
      this.$router.go(this.$router.currentRoute)
    },

    changeSimbol(s) {
      //var accent_map = {'á':'&aacute;', 'é':'&eacute;', 'è':'e', 'í':'&iacute;','ó':'&oacute;','ú':'&uacute;','Á':'&Aacute;', 'É':'&Eacute;', 'è':'e', 'Í':'&Iacute;','Ó':'&Oacute;','Ú':'&Uacute;', 'ñ':'&ntilde;;', 'Ñ':'&Ntilde;'};
      var accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u', 'Ñ':'N', 'ñ':'n'};
      if (!s) { return ''; }
      var ret = '';
      for (var i = 0; i < s.length; i++) {
        ret += accent_map[s.charAt(i)] || s.charAt(i);
      }
      return ret;
    },

    async getUsuarios() {
      this.arqueo.agencia_seleccionada_id = this.arqueo.agencia_seleccionada.id;
      await this.$store.dispatch("agencias/listUser", this.arqueo.agencia_seleccionada.id).then(() => {
        const usuarios = this.$store.getters["agencias/listUser"];
        this.usuarios = usuarios.filter(u => {
          if (!u.role) return false;
          const role = u.role.toLowerCase();
          
          return role.includes('taquiller') || 
                 role.includes('supervision taquilla') || 
                 role.includes('supervisión taquilla');
        });
      });
    },

    async authAgencias(){
      this.permiso.permiso = 'view arqueos cualquier agencia';
      try {
      await this.$store.dispatch("ventas/verificacion", this.permiso);
        this.permiso.validacion = true;
        //this.getAgencias();
      }catch (error) {
        this.permiso.validacion = false;
      }
    },

    async getAgencias() {
      await this.$store.dispatch("agencias/listActive").then(() => {
        this.agencias = this.$store.getters["agencias/listActive"];
      });
      let me = await this.$store.getters["profile/me"];
      if(me.attributes.agencia_activa != 'sin agencia'){
        this.arqueo.agencia_seleccionada = this.agencias.find(item => item.nombre == me.attributes.agencia_activa);
        this.arqueo.agencia_seleccionada_id = this.arqueo.agencia_seleccionada.id;
        this.arqueo.agencia_id = this.arqueo.agencia_seleccionada.id; 
      }
    },

    calculaEfectivo(){
      /*
      let total = 0;
      let count = 0;
      for(let i = 0; i < this.consulta.ingresos_efectivo_mxn.length; i++){
        if(this.consulta.ingresos_efectivo_mxn[i].monto !== 0){
          total = total + Number(this.consulta.ingresos_efectivo_mxn[i].monto);
          count++
        }
      }
      this.metodos[1].movimiento = count;
      this.metodos[1].monto = '$'+(total).toFixed(2);
      */
    },

    consultar(){
      this.consulta = null;
      this.consulta_validacion = false;
      this.arqueo.emitido = new Date();
      //formatos de fechas inicio y fin
      var fecha_inicio = this.arqueo.fecha_inicio;
      var fecha_inicio_format = fecha_inicio.getFullYear()  + "-" + ("0"+(fecha_inicio.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_inicio.getDate()).slice(-2) + " " + ("0" + fecha_inicio.getHours()).slice(-2) + ":" + ("0" + fecha_inicio.getMinutes()).slice(-2);
      
      var fecha_fin = this.arqueo.fecha_fin;
      var fecha_hora = new Date(new Date().setHours(23,59,59,0));
      
      var fecha_fin_format = fecha_fin.getFullYear()  + "-" + ("0"+(fecha_fin.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_fin.getDate()).slice(-2) + " " + ("0" + fecha_hora.getHours()).slice(-2) + ":" + ("0" + fecha_hora.getMinutes()).slice(-2);

      if(fecha_inicio_format >= fecha_fin_format){
        this.$notify({
          type: "danger",
          message: "El momento fin debe ser mayor que el momento inicio",
          duration: -1
        });
        return;
      }
      if(this.arqueo.agencia_seleccionada === null){
        this.$notify({
          type: "danger",
          message: "Es necesario seleccionar una agencia",
          duration: -1
        });
        return;
      }
      if(this.arqueo.usuario != null){
        this.arqueo.user_id = this.arqueo.usuario.id; 
      }
      const url = process.env.VUE_APP_API_BASE_URL;
    
      try{
        const promise = axios.get(`${url}/movimientos_caja/arqueo`+'?momento_inicio='+fecha_inicio_format+'&momento_fin='+fecha_fin_format+'&agencia_id='+this.arqueo.agencia_id+'&agencia_seleccionada_id='+this.arqueo.agencia_seleccionada_id+'&user_id='+this.arqueo.user_id)
        return promise.then(data => {
          this.consulta = data.data.data.attributes;
          this.consulta_validacion = true;
          //this.calculaEfectivo();
          this.ingresos[0].movimiento = this.consulta.ingresos_efectivo_mxn[0].movimientos;
          this.ingresos[0].monto = '$'+Number(this.consulta.ingresos_efectivo_mxn[0].monto).toFixed(2);
          /*
          this.ingresos[1].movimiento = this.consulta.ingresos_efectivo_usd[0].movimientos;
          this.ingresos[1].monto = 'USD '+Number(this.consulta.ingresos_efectivo_usd[0].monto).toFixed(2);
          */
          this.ingresos[1].movimiento = this.consulta.ingresos_tarjeta[0].movimientos;
          this.ingresos[1].monto = '$'+Number(this.consulta.ingresos_tarjeta[0].monto).toFixed(2);

          this.egresos[0].movimiento = this.consulta.egresos[0].movimientos;
          this.egresos[0].monto = '$'+Number(this.consulta.egresos[0].monto).toFixed(2);
        });
      }catch(error){
        console.log(error)
      }
    },

    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      if (this.hora_salida != null) {
        var hora = this.hora_salida;
        var hora_salida =
          this.pad(hora.getHours()) + ":" + this.pad(hora.getMinutes());
      }
      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
          ...(this.query ? { search: this.query } : {}),
          ...(this.fecha_salida ? { fecha_salida: this.fecha_salida } : {}),
          ...(hora_salida ? { hora_salida: hora_salida } : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };

      await this.$store.dispatch("corridas/list", params).then(() => {
        this.corridas = this.$store.getters["corridas/list"];
        this.total = this.$store.getters["corridas/listTotal"];
      });
      this.loading = false;
    },

    pad(value) {
      if (value < 10) {
        return "0" + value;
      } else {
        return value;
      }
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
  
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
<style lang="scss">
.argon-error {
position: relative;
bottom: 25px !important;
color: #fb6340;
}
.table-container {
//width: 100em;
overflow-x: auto !important;
white-space: nowrap !important;
}

.argon-error {
position: relative;
bottom: 25px !important;
color: #fb6340;
}
</style>
